import React from "react";
import { useAppSelector } from "../../../../Redux/hooks";
import { Box, Typography } from "@mui/material";
import { EmptyMessageWrapper, ConsentListStyle } from "../block.style";
import ConsentItemWrapper from "./ConsentItemWrapper";

const DropArea: React.FC = () => {
  const blocks = useAppSelector((state) => state.consent.blocks);

  return (
    <Box sx={ConsentListStyle}>
      {blocks.length > 0 ? (
        blocks.map((block, index) => (
          <ConsentItemWrapper key={block.id} index={index} block={block} />
        ))
      ) : (
        <EmptyMessageWrapper>
          <Typography variant="h3" color="grey">
            No consent block added yet
          </Typography>
        </EmptyMessageWrapper>
      )}
    </Box>
  );
};

export default DropArea;
